import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { TmAccount } from '@/tscapi/model/account';
import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

export const useAccount = (isAuth: boolean) => {
    const cookie: Cookie = new Cookie();
    return useQuery({
        queryKey: ['account', cookie.UserAccessToken?.Edp, cookie.Language],
        queryFn: fetchAccount,
        useErrorBoundary: true,
        enabled: isAuth,
        retry: false,
        refetchOnWindowFocus: false,
    });

    async function fetchAccount(): Promise<TmAccount> {
        const base = '/api/v2/';
        const lang = cookie.Language.substring(0, 2) || 'en';
        const userAccessTokenEdp = cookie.UserAccessToken?.Edp;
        if (
            !(
                cookie.UserAccessToken != undefined &&
                cookie.UserAccessToken.Token.length > 0 &&
                cookie.UserAccessToken.Edp > 0
            )
        ) {
            throw new Error('UserToken expired');
        }
        try {
            const response = await http.get(`${base}${lang}/accounts/${userAccessTokenEdp}`);
            return response.data;
        } catch (error) {
            //if this state happens, user will be re-directed to signin page anyway
            console.log('Error getting Account');
            throw new Error('Error getting Account');
        }
    }
};

export const useUpdatePassword = (CustomerEdp: number, showSuccess, handleAccordion) => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';

    type PasswordRequestPayload = {
        NewPassword: string;
        NewPasswordConfirmed: string;
        Username: string;
        CurrentPassword: string
    };

    const updatePassword = (passwordRequestPayload: PasswordRequestPayload) => {
        return http.put(`${base}${lang}/accounts/${CustomerEdp}/password`, passwordRequestPayload);
    };
    return useMutation({
        onSuccess: async (response, variables, context) => {
            // setupAnalyticsData(response.data);
            showSuccess('password');
            handleAccordion(0, false);
        },
        onError: (error, variables, context) => {
            console.log('error');
        },
        mutationFn: updatePassword,
    });
};
